import { Col } from "reactstrap";
import { findOutClassStatBoxes } from "./Utility";
import typography from "./typography";

export default function StatBoxes({ data = {}, isVertical = false }) {
  const STAT_BOXES = [
    {
      HEADING: typography.TOTAL_USERS_ALL_TIME,
      COUNT: data?.totalUsersAllTime ?? 0,
    },
    {
      HEADING: typography.PAID_USERS,
      COUNT: data?.paidUsers ?? 0,
    },
    {
      HEADING: typography.FREE_USERS,
      COUNT: data?.freeUsers ?? 0,
    },
  ];

  const cardColumnProps = isVertical
    ? { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" }
    : { xl: "4", md: "6", sm: "6", xs: "12" };

  return (
    <>
      {STAT_BOXES.map((el, idx) => (
        <Col {...cardColumnProps} className="mb-3" key={idx}>
          <div className={`stat-boxes-con p-3 ${findOutClassStatBoxes(el.HEADING)}`}>
            <p className="standard-typo-14-500-ld ft-white">{el.HEADING}</p>
            <h1 className="ft-white stat-box-heading font-family-lexend">{el.COUNT}</h1>
          </div>
        </Col>
      ))}
    </>
  );
}
